/**
 * PasskeyButton Component
 *
 * A button for logging in with passkeys (WebAuthn).
 * Shows device-specific icons (Face ID, Touch ID, Windows Hello).
 *
 * Renders immediately on page load (SSR) for no layout shift.
 * Only hides if passkeys are explicitly not supported (rare).
 */

"use client";

import { c as _c } from "react/compiler-runtime";
import { T, Var } from "gt-next";
import { usePasskeyLogin } from "@/hooks/usePasskeys";
import { BiometricIcon } from "@/components/presentational/tailwind/PasskeyManagement";
interface PasskeyButtonProps {
  onSuccess?: (redirectUrl?: string) => void;
  isLogin?: boolean;
}
export function PasskeyButton(t0) {
  const $ = _c(16);
  const {
    onSuccess,
    isLogin: t1
  } = t0;
  const isLogin = t1 === undefined ? true : t1;
  const {
    isPasskeySupported,
    isReady,
    biometricType,
    biometricDisplayName,
    authenticateWithPasskey,
    isAuthenticating
  } = usePasskeyLogin();
  if (!isPasskeySupported) {
    return null;
  }
  let t2;
  if ($[0] !== authenticateWithPasskey || $[1] !== isAuthenticating || $[2] !== isReady || $[3] !== onSuccess) {
    t2 = async () => {
      if (!isReady || isAuthenticating) {
        return;
      }
      const result = await authenticateWithPasskey();
      if (result.success && onSuccess) {
        onSuccess(result.redirectUrl);
      }
    };
    $[0] = authenticateWithPasskey;
    $[1] = isAuthenticating;
    $[2] = isReady;
    $[3] = onSuccess;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const handleClick = t2;
  let t3;
  if ($[5] !== biometricType) {
    t3 = <BiometricIcon type={biometricType} className="h-5 w-5" />;
    $[5] = biometricType;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== biometricDisplayName || $[8] !== isAuthenticating || $[9] !== isLogin) {
    t4 = <span>{isAuthenticating ? <T>Authenticating...</T> : isLogin ? <T>Log in with <Var name="method">{biometricDisplayName}</Var></T> : <T>Sign up with <Var name="method">{biometricDisplayName}</Var></T>}</span>;
    $[7] = biometricDisplayName;
    $[8] = isAuthenticating;
    $[9] = isLogin;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== handleClick || $[12] !== isAuthenticating || $[13] !== t3 || $[14] !== t4) {
    t5 = <button className="shadow-xs focus:outline-hidden flex w-full cursor-pointer items-center justify-center gap-3 rounded-[16px] border border-gray-300 bg-white px-4 py-3.5 text-[15px] font-medium text-gray-800 transition-all duration-150 hover:border-gray-400 hover:bg-gray-50 focus:ring-2 focus:ring-gray-900 focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50" disabled={isAuthenticating} onClick={handleClick} type="button" aria-busy={isAuthenticating}>{t3}{t4}</button>;
    $[11] = handleClick;
    $[12] = isAuthenticating;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  return t5;
}